import classnames from 'classnames/bind'
import { createPortal } from 'react-dom'

import { useBodyScrollLock } from '@unlikelystudio/react-hooks'

import Image, { ImageProps } from '~/components/UI/Image'
import ImageGalleryControls from '~/components/UI/ImageGallery/ImageGalleryControls'
import { ProductImagesZoomProps } from '~/components/UI/ProductHeader/ProductImagesZoom'

import css from './styles.module.scss'

const cx = classnames.bind(css)

export interface ImageGalleryProps {
  className?: string
  imageIndex?: number
  imagesProps?: ImageProps[]
  isFragrance?: ProductImagesZoomProps['isFragrance']
  onPreviousClick?: ProductImagesZoomProps['onPreviousClick']
  onNextClick?: ProductImagesZoomProps['onNextClick']
  onExitFullscreen?: () => void
}

export default function ImageGallery({
  className,
  imageIndex,
  imagesProps,
  isFragrance,
  onPreviousClick,
  onNextClick,
  onExitFullscreen,
}: ImageGalleryProps) {
  useBodyScrollLock(true)
  if (!document?.body) {
    return null
  }

  return createPortal(
    <div className={cx(className, css.ImageGallery)}>
      <ImageGalleryControls
        className={cx(css.controls, { isFragrance })}
        imageIndex={imageIndex}
        imagesProps={imagesProps}
        onPreviousClick={onPreviousClick}
        onNextClick={onNextClick}
        onExitFullscreen={onExitFullscreen}
      />
      <div className={css.imageContainer}>
        <Image
          onClick={onExitFullscreen}
          className={cx(css.image)}
          layout="fill"
          objectFit="cover"
          sizesFromBreakpoints={[{ ratio: 1 }]}
          asPlaceholder
          {...imagesProps?.[imageIndex]}
        />
      </div>
    </div>,
    document?.body,
  )
}
